import { ChartColor } from "./chart";
import { ExcahngeRate } from "./exchange-rate";

export enum PriceChartDuration {
    OneDay = '1D',
    SevenDays = '7D',
    OneMonth = '1M',
    ThreeMonths = '3M',
    OneYear = '1Y',
}

export interface PriceDataPoint {
  x: number;
  y: number;
}

export interface PriceDataPointSeries {
  baseCurrencyData: PriceDataPoint[];
  globalCurrencyData: PriceDataPoint[];
}

export interface PriceDataItem {
  currency: string;
  data: PriceDataPoint[];
}

export interface PriceDataSeries {
  baseCurrencyData: PriceDataItem;
  globalCurrencyData: PriceDataItem;
  defaultCurrencyData: PriceDataItem;
}

export interface CryptoPriceData {
  pair: string;
  mainCurrency: string;
  priceChangePercentage: number;
  isPositvitePriceChange: boolean;
  baseCurrency: CryptoPriceDataInfo;
  globalCurrency: CryptoPriceDataInfo;
  defaultCurrency: CryptoPriceDataInfo;
  chartColor: ChartColor;
  priceHistory: PriceDataSeries;
  livePriceHistory: PriceDataSeries;
}

export interface CryptoPriceDataInfo {
  currency: string;
  lastPrice: number;
  priceChange: number;
  priceHistory: PriceDataPoint[];
}
